
import React from "react";
import "./Sidebar.css";
import { FaUser, FaHome, FaUsers, FaFileInvoiceDollar, FaKey, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';

const Sidebar = () => {

  const navigate =useNavigate();
  const dispatch = useDispatch();

  const [userName, setUserName] = useState<string>("משתמש");
  useEffect(() => {
      const savedUser = localStorage.getItem("user");
      if (savedUser) {
        try {
          const parsedUser = JSON.parse(savedUser);
          setUserName(parsedUser.fullName || "משתמש מחובר");
        } catch (e) {
          console.error("Error parsing user from localStorage", e);
        }
      }
    }, []);
  const menuItems = [
    { label: userName, icon: < FaUser size={43}/>},
    { label: "דף הבית", icon: <FaHome size={43}/>, path: "/" },
    { label: "עסקים", icon: <FaUsers size={43}/>, path: "/business" },
    { label: "דוחות", icon: <FaFileInvoiceDollar size={43}/>, path: "/reports" },
    { label: "הרשאות", icon: <FaKey size={43}/>, path: "/permission" },
  ];
const handleLogoutClick = () => {
    localStorage.removeItem("user");

  // 2. מעדכנים את רדאקס (והשוטר ב App.tsx כבר יזהה את השינוי וינווט לבד!)
  dispatch({ type: "SIGN_OUT" });
  };
  return (<>
    <div className="sidebar">
      {/* {menuItems.map((item, index) => (
        <a key={index} href={item.link} className="sidebar-item">
          <div className="sidebar-icon" style={{width:"80px", height:"80px"}} >{item.icon}</div>

          <span className="sidebar-label">{item.label}</span>
        </a>
      ))} */}
        {menuItems.map((item, index) => (
          <div
            key={index}
            className="sidebar-item"
            onClick={() => navigate(item.path|| "/")}
            style={{ cursor: "pointer" }}
          >
            <div
              className="sidebar-icon"
              style={{ width: "80px", height: "80px" }}
            >
              {item.icon}
            </div>
            <span className="sidebar-label">{item.label}</span>
          </div>
        ))}
            {/* <div className="sidebar-footer" > */}
      <div
  className="sidebar-item logout"
  style={{ bottom: '0', right: '2', position: "fixed", cursor: "pointer" }}
  onClick={() =>handleLogoutClick()}
>
  <div className="logout-icon">
    <FaSignOutAlt size={20} />
  </div>
  <span className="item-text">התנתק</span>
</div>

      </div>
    {/* </div> */}

    </>
  );
};

export default Sidebar;
